import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="text-center max-w-md">
        {/* 404 Display */}
        <div className="mb-6">
          <h1 className="text-7xl sm:text-8xl font-bold text-primary">404</h1>
          <div className="h-1 w-16 bg-primary mx-auto mt-4 rounded-full" />
        </div>

        {/* Message */}
        <h2 className="text-xl sm:text-2xl font-semibold text-foreground mb-2">
          Page not found
        </h2>
        <p className="text-muted-foreground mb-8">
          Sorry, we couldn't find the page you're looking for. It may have been moved or deleted.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild size="lg">
            <Link to="/" className="gap-2">
              <Home className="h-4 w-4" />
              Go to Home
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg">
            <Link to="javascript:history.back()" className="gap-2" onClick={(e) => { e.preventDefault(); history.back(); }}>
              <ArrowLeft className="h-4 w-4" />
              Go Back
            </Link>
          </Button>
        </div>
      </div>

      {/* Footer */}
      <footer className="absolute bottom-6 text-center">
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} My Professional Tax
        </p>
      </footer>
    </div>
  );
}
